<template>
  <div
    v-if="props.reservation && props.reservation.policy === 'deposit'"
    class="flex w-full mb-4 justify-center"
  >
    <l-status status="pending" type="secondary" size="small" :show-icon="true">{{
      t('checkout.deposit-warning', {
        amount: currency(props.reservation.policyAmount)
      })
    }}</l-status>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { LStatus } from '@last/core-ui/paprika'

import { useMoney } from '@/composables/useMoney'
import type { Reservation } from '@/types'

const { currency } = useMoney()

const props = defineProps<{
  reservation: Reservation | undefined
}>()

const { t } = useI18n()
</script>
